import MuiChip from "@mui/material/Chip";
import { tokens } from "../tokens";
import { cleanProps } from "../internal/cleanProps";
import { Icon } from "./Icon";
import type { StatusIndicatorProps, StatusIndicatorTone } from "../types";

const TONE_COLOUR: Record<StatusIndicatorTone, { text: string; surface: string }> = {
  success: tokens.colour.status.success,
  warning: tokens.colour.status.warning,
  error: tokens.colour.status.error,
  info: tokens.colour.status.info,
  neutral: { text: tokens.colour.neutral.ink, surface: tokens.colour.neutral.surface },
};

/**
 * Not a named upstream component — composed from `Chip`, which this
 * adapter does not expose generically (no containment note beyond "no
 * Material UI type crosses the boundary"). Colour is never the only
 * signal: `label` always renders as text alongside the tone colouring.
 */
export function StatusIndicator({ status, label, icon, testId }: Readonly<StatusIndicatorProps>) {
  const { text, surface } = TONE_COLOUR[status];

  return (
    <MuiChip
      label={label}
      sx={{ color: text, backgroundColor: surface, fontWeight: tokens.typography.weights.bold }}
      {...cleanProps({
        icon: icon !== undefined ? <Icon name={icon} /> : undefined,
        "data-testid": testId,
      })}
    />
  );
}
